export const ITEM_HEIGHT = 40
export const LIST_MAX_HEIGHT = ITEM_HEIGHT * 6.75
